var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.227,59.973C112.598,60.465 111.805,61.066 109.016,63.09C108.469,63.5 107.457,64.402 106.5,64.402C105.516,64.402 104.531,63.5 103.957,63.09C101.168,61.066 100.375,60.465 99.746,59.973C99.637,59.891 99.5,59.973 99.5,60.109L99.5,65.688C99.5,66.426 100.074,67 100.812,67L112.188,67C112.898,67 113.5,66.426 113.5,65.688L113.5,60.109C113.5,59.973 113.336,59.891 113.227,59.973ZM106.5,63.5C107.129,63.527 108.031,62.707 108.496,62.379C112.133,59.754 112.406,59.508 113.227,58.852C113.391,58.742 113.5,58.551 113.5,58.332L113.5,57.813C113.5,57.102 112.898,56.5 112.188,56.5L100.812,56.5C100.074,56.5 99.5,57.102 99.5,57.813L99.5,58.332C99.5,58.551 99.582,58.742 99.746,58.852C100.566,59.508 100.84,59.754 104.477,62.379C104.941,62.707 105.844,63.527 106.5,63.5Z",
    transform: "matrix(1,0,0,1,-99,-54)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.ba0f0888.svg";
export { ForwardRef as ReactComponent };